import { API_ROOT, PACKAGE_ID } from '../config';
import fetch from '../utils/fetch';

export const registerUser = (clientToken, email, password, name, phone) => {
  const userData = {
    email,
    password,
    name,
    cell_phone: phone,
  };

  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken,
    },
    body: JSON.stringify(userData),
  };

  return fetch(`${API_ROOT}auth/try-free/`, config).then(response => {
    if (response.headers.get('content-type') !== 'application/json') {
      return {
        error: response.statusText,
        errorCode: response.status,
      };
    }

    return response.json().then(json => {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status,
        };
      }

      const data = json.results;

      return data;
    });
  });
};

export const registerOrg = (
  clientToken,
  name,
  domain,
  subdomain,
  userId,
  sessionId,
  userToken,
) => {
  const orgData = {
    organization_name: name,
    organization_domain: `https://${domain}`,
    subdomain_url: `https://${subdomain}.spotmentor.com`,
    user_id: userId,
    session_code: sessionId,
    package_id: PACKAGE_ID,
  };

  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken,
      'User-Access-Token': userToken,
    },
    body: JSON.stringify(orgData),
  };

  return fetch(`${API_ROOT}organization/register/`, config).then(response => {
    if (response.headers.get('content-type') !== 'application/json') {
      return {
        error: response.statusText,
        errorCode: response.status,
      };
    }

    return response.json().then(json => {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status,
        };
      }

      const data = json.results;

      return data;
    });
  });
};

export const getRegistrationFields = (clientToken, hashCode) => {
  const config = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken,
    },
  };

  return fetch(
    `${process.env.SAG_ROOT}/get-org-reg-fields?code=${hashCode}`,
    config,
  ).then(response => {
    if (response.headers.get('content-type') !== 'application/json') {
      return {
        error: response.statusText,
        errorCode: response.status,
      };
    }

    return response.json().then(json => {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status,
        };
      }

      const data = json.results;

      return data;
    });
  });
};

const standardRegFields = ['name', 'email', 'password'];

export const registerUserToOrg = (clientToken, orgId, userDetails) => {
  const standardDetails = {};
  const customRegDetails = {};
  const keys = Object.keys(userDetails);

  for (let i = keys.length - 1; i >= 0; i -= 1) {
    const key = keys[i];

    if (standardRegFields.includes(key)) {
      standardDetails[key] = userDetails[key];
    } else {
      customRegDetails[key] = userDetails[key];
    }
  }

  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken,
    },
    body: JSON.stringify({
      organization_id: orgId,
      custom_fields: customRegDetails,
      ...standardDetails,
    }),
  };

  return fetch(`${process.env.SAG_ROOT}/register`, config).then(response => {
    if (response.headers.get('content-type') !== 'application/json') {
      return {
        error: response.statusText,
        errorCode: response.status,
      };
    }

    return response.json().then(json => {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status,
        };
      }

      const data = json.results;

      return data;
    });
  });
};

export const listOrgProfiles = async (clientToken, orgId) => {
  const config = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken,
    },
  };

  try {
    const roles = await fetch(
      `${process.env.SAG_ROOT}/list-profiles-for-organization?organization_id=${orgId}`,
      config,
    );
    const jsonRoles = await roles.json();

    return {
      roles: jsonRoles && jsonRoles.results,
      error: null,
    };
  } catch (err) {
    console.error(err);
    return {
      roles: [],
      error: 'Error while fetching roles',
    };
  }
};



// WEBPACK FOOTER //
// ./src/actions/registration.js